import { createFileRoute } from '@tanstack/react-router'
import { TrainersListPage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainers/')({
  component: TrainersListPage,
})
